import { Component, Input } from '@angular/core';
import {
  getPasswordPolicyChecks,
  PASSWORD_MIN_LENGTH,
  PASSWORD_SPECIAL_CHARS,
} from '../password-policy.validator';

@Component({
  selector: 'app-password-policy-hints',
  templateUrl: './password-policy-hints.component.html',
  styleUrls: ['./password-policy-hints.component.scss'],
})
export class PasswordPolicyHintsComponent {
  @Input() password = '';
  @Input() layout: 'grid' | 'stack' = 'grid';

  readonly specialChars = PASSWORD_SPECIAL_CHARS;
  readonly minLength = PASSWORD_MIN_LENGTH;

  get checks() {
    return getPasswordPolicyChecks(this.password);
  }

  get rules() {
    return [
      { name: 'Minimum length', hint: `${this.minLength} characters`, met: this.checks.hasMinLength, fullWidth: true },
      { name: 'Uppercase', hint: 'A-Z', met: this.checks.hasUppercase, fullWidth: false },
      { name: 'Lowercase', hint: 'a-z', met: this.checks.hasLowercase, fullWidth: false },
      { name: 'Number', hint: '0-9', met: this.checks.hasNumber, fullWidth: false },
      { name: 'Special character', hint: this.specialChars, met: this.checks.hasSpecialChar, fullWidth: false },
    ];
  }
}
